// extracted by mini-css-extract-plugin
export default {"form-container":"AddBook_form-container__Wd+ae","form-title":"AddBook_form-title__ibNHG"};